import { queryOptions } from "@tanstack/react-query";
import { LST_FAV, LST_FVT } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type { LikeListResponse } from "./types";

/** 相手から（自分がもらった）いいね一覧 — lst_fvt */
export const receivedLikeListQueryOptions = queryOptions({
  queryKey: queryKeys.like.received(),
  queryFn: () => apiClient<LikeListResponse>(LST_FVT),
});

/** 自分から（自分が送った）いいね一覧 — lst_fav */
export const sentLikeListQueryOptions = queryOptions({
  queryKey: queryKeys.like.sent(),
  queryFn: () => apiClient<LikeListResponse>(LST_FAV),
});
